'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

const APP_URL = process.env.NEXT_PUBLIC_SITE_URL || '';

const PoweredByWebApp = dynamic(
  () => import('../../poweredby/src/app/App.web'),
  {
    ssr: false,
    loading: () => (
      <div className={'flex items-center justify-center w-full min-h-screen'}>
        {'Loading app...'}
      </div>
    ),
  },
);

/**
 * Cross-origin: redirect to NEXT_PUBLIC_SITE_URL.
 * Same host (or no URL configured): mount the React Native Web app inline.
 */
export default function Index() {
  const [showApp, setShowApp] = useState(false);

  useEffect(() => {
    const raw = APP_URL.trim();
    if (!raw || raw === '/') {
      setShowApp(true);
      return;
    }
    try {
      const resolved = new URL(raw, window.location.origin);
      if (resolved.origin !== window.location.origin) {
        window.location.replace(resolved.toString());
        return;
      }
    } catch {
      setShowApp(true);
      return;
    }
    setShowApp(true);
  }, []);

  if (!showApp) {
    return (
      <div className={'flex items-center justify-center w-full min-h-screen'}>
        {'Loading app...'}
      </div>
    );
  }

  return <PoweredByWebApp />;
}
